//TobTab.jsx

import React from "react";

export default function TopTabs({ activeTab, setActiveTab, jobId }) {
    const tabs = [
        { id: "overview", label: "Overview" },
        { id: "hotspots", label: "Hotspots" },
        { id: "architecture", label: "Architecture" },
        { id: "agent", label: "Agent" }
    ];

    return (
        <div className="custor-tabs">
            {tabs.map(tab => (
                <div
                    key={tab.id}
                    className={`tab ${activeTab === tab.id ? "active" : ""}`}
                    onClick={() => jobId && setActiveTab(tab.id)}
                    style={{
                        opacity: jobId ? 1 : 0.4,
                        pointerEvents: jobId ? "auto" : "none"
                    }}
                >
                    {tab.label}
                </div>
            ))}
        </div>
    );
}